export const projectStatus = [
  {
    label: "进度正常",
    value: "进度正常",
    color: "#69e0af"
  },
  {
    label: "存在风险",
    value: "存在风险",
    color: "#FFA150"
  },
  {
    label: "项目逾期",
    value: "项目逾期",
    color: "#FF7373"
  }
]

export const priorityLevel = [
  {
    label: "低",
    value: "0",
    color: "#C0C4CC"
  },
  {
    label: "中",
    value: "1",
    color: "#1989FA"
  },
  {
    label: "高",
    value: "2",
    color: "#F8B174"
  },
  {
    label: "紧急",
    value: "3",
    color: "#FF7373"
  }
]

export const taskDueDateStatus ={
  normal: "#606266",
  warning: "#FFA150",
  danger: "#FF7373"
}

